import * as z from "zod";

export const AdminDevStatus = z.object({
  /** The backend pulls Stripe and LiveKit itself (local only) and serves `POST /dev/refresh`. */
  providerSync: z.boolean(),
});
export type AdminDevStatus = z.output<typeof AdminDevStatus>;

/** What one pull did: events replayed through the webhook handlers, and LiveKit changes applied. */
export const ProviderSync = z.object({
  stripeEventsReplayed: z.number(),
  stripeEventsFailed: z.number(),
  liveActionsApplied: z.number(),
  liveStreamsFailed: z.number(),
});
export type ProviderSync = z.output<typeof ProviderSync>;
